import { Link } from "@remix-run/react"
import routes from "#routes"
import {
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
} from "../ui/dropdown-menu"
import { Icon } from "../ui/icon"

export default function AdminUserDropdown() {
	return (
		<DropdownMenuGroup>
			<DropdownMenuLabel>Administrador</DropdownMenuLabel>
			<Link prefetch="intent" to={routes.admin.users.route()}>
				<DropdownMenuItem className="flex cursor-pointer items-center gap-1">
					<Icon name="avatar">Usuarios</Icon>
				</DropdownMenuItem>
			</Link>
			<Link prefetch="intent" to={routes.admin.orders.route()}>
				<DropdownMenuItem className="flex cursor-pointer items-center gap-1">
					<Icon name="cube">Pedidos</Icon>
				</DropdownMenuItem>
			</Link>
			<Link prefetch="intent" to={routes.admin.products.route()}>
				<DropdownMenuItem className="flex cursor-pointer items-center gap-1">
					<Icon name="lucide-tag">Productos</Icon>
				</DropdownMenuItem>
			</Link>
			<Link prefetch="intent" to={routes.admin.contacts.route()}>
				<DropdownMenuItem className="flex cursor-pointer items-center gap-1">
					<Icon name="envelope-closed">Solicitudes contacto</Icon>
				</DropdownMenuItem>
			</Link>
		</DropdownMenuGroup>
	)
}
